import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32163 27601"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:356.425}.fil0{fill:#2b2a29}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528318417696">
        <path
          d="M30165 1375H1998c-122 0-221-99-221-221s99-220 221-220h28167c122 0 221 98 221 220s-99 221-221 221z"
          className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}
        />
        <path
          d="M1154 620c-294 0-534 240-534 534 0 295 240 535 534 535 295 0 535-240 535-535 0-294-240-534-535-534zm0 1511c-538 0-976-438-976-977 0-538 438-976 976-976 539 0 977 438 977 976 0 539-438 977-977 977zM31009 620c-295 0-535 240-535 534 0 295 240 535 535 535s534-240 534-535c0-294-239-534-534-534zm0 1511c-538 0-977-438-977-977 0-538 439-976 977-976s976 438 976 976c0 539-438 977-976 977zM29313 27422H2850V1154c0-121 99-220 221-220s221 99 221 220v25826h25579V1154c0-121 99-220 221-220s221 99 221 220v26268z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M28330 26439H3833V1154c0-121 99-220 221-220s221 99 221 220v24843h23614V1154c0-121 98-220 220-220s221 99 221 220v25285z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M16082 26439c-122 0-221-99-221-221V1154c0-122 99-220 221-220s220 98 220 220l1 25064c0 122-99 221-221 221z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M4756 26439c-73 0-144-36-186-100-67-102-38-240 64-306 9147-5989 10859-18284 11170-23299v-7c51-827 56-1361 56-1505v-5c1-13 1-23 1-32v-31c0-122 99-220 221-220s220 98 220 220l1 31c0 11-1 25-1 41 0 151-5 692-56 1522l-1 7c-136 2206-608 6593-2235 11178-1989 5608-5062 9803-9134 12470-38 24-79 36-120 36z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M4054 20627c-77 0-152-40-192-112-61-106-24-241 83-301 8699-4955 11069-12619 11707-16758v-36l9-16c176-1169 197-1966 199-2184 1-16 1-26 1-35v-31c0-122 99-220 221-220s220 98 220 220l1 31c0 12-1 26-1 44-2 222-24 1052-208 2260v36l-8 17c-304 1961-1039 4942-2814 8068-2116 3726-5181 6751-9109 8988-35 19-72 29-109 29z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M4054 15410c-80 0-158-43-197-120-56-108-13-242 96-297 8772-4481 11100-9176 11706-11575 62-242 111-482 148-712 22-142 41-284 55-423 6-64 12-125 16-184 26-365 15-631 0-789-7-77-14-118-14-119-20-120 61-234 181-254 120-21 234 60 255 180 0 6 9 58 18 152 16 176 29 467 1 862-5 62-11 127-17 195-15 148-35 299-59 450-39 243-91 495-156 750-451 1783-1448 3566-2964 5297-2084 2380-5102 4588-8969 6564-32 16-66 23-100 23z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M27441 26439c-42 0-83-12-121-36-4072-2667-7145-6862-9134-12470-1627-4586-2099-8972-2235-11178-48-777-56-1311-57-1505-1-64 0-98 0-98 1-122 100-221 223-218 122 1 220 101 218 223 0 2 0 32 1 90 1 190 9 715 56 1480 310 5011 2019 17314 11170 23306 102 66 131 204 64 306-42 64-113 100-185 100zM29125 21161c-35 0-69-8-102-25l-7-4c-10-5-21-10-31-16-107-60-145-194-86-301 59-106 193-145 300-86 6 4 13 7 19 10l8 4c108 56 151 190 95 298-39 76-116 120-196 120z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M28109 20608c-37 0-74-9-109-29-3917-2238-6973-5260-9083-8982-1781-3141-2512-6134-2813-8092-176-1154-206-1960-210-2253-1-66 0-100 0-100 1-122 101-219 223-218s220 101 218 223c0 2 0 32 1 90 4 283 32 1064 205 2192 633 4127 2992 11793 11678 16756 106 60 143 196 83 302-42 71-116 111-193 111zM29125 15898c-32 0-65-6-96-21l-7-3c-10-6-21-11-32-16-108-56-150-190-95-298 57-108 190-150 299-95 6 4 12 7 19 10l7 3c110 54 157 186 104 295-38 80-117 125-199 125z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
        <path
          d="M28109 15394c-34 0-68-8-100-24-3855-1974-6864-4179-8942-6555-1513-1729-2508-3508-2958-5289l-7-28c-61-242-111-485-149-722l-2-18c-29-184-52-365-66-540l-8-7v-93c-10-149-16-295-16-436 0-188 10-328 17-413 9-94 18-146 18-152 22-121 136-201 256-180 120 20 201 135 180 255 0 0-7 41-14 118-7 75-16 201-16 372 1 133 6 274 17 417l4 50c14 180 37 367 66 556l3 18c37 228 86 461 145 693l7 29c616 2403 2953 7072 11666 11531 108 56 152 189 96 297-39 77-117 121-197 121z"
                    className="fill stroke1"
          style={{
            strokeWidth: 303.925,
          }}

        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
